module.exports = __webpack_public_path__ + "img/maoyi.34319aa3.jpg";